import axios from 'axios';
import format from 'date-fns/format';

import {
  FETCH_EXPENSES,
  FETCH_EXPENSES_SUCCESS,
  FETCH_EXPENSES_ERROR,
  FETCH_EXPENSES_SERVER_ERROR,
  TOGGLE_ROAMING,
  FILTER_ACCUMULATORS,
  TOGGLE_TABS,
  FILTER_PATH_CTN,
  API_DATE_FORMAT,
  TABLE_FILTERS_CLEAR,
  TABLE_FILTERS,
} from './constants';

const formatDate = (date) => format(date, API_DATE_FORMAT);

export function filterAccumulator(data) {
  return {
    type: FILTER_ACCUMULATORS,
    data,
  };
}

export function fetchExpensesStart() {
  return {
    type: FETCH_EXPENSES,
  };
}

export function fetchExpensesSuccess(data) {
  return {
    type: FETCH_EXPENSES_SUCCESS,
    data,
  };
}

export function filterPathCtn(data) {
  return {
    type: FILTER_PATH_CTN,
    data,
  };
}

export function fetchExpensesError(error, isServerError = false) {
  if (isServerError) {
    return {
      type: FETCH_EXPENSES_SERVER_ERROR,
      error: 'SERVER_ERROR',
    };
  }

  return {
    type: FETCH_EXPENSES_ERROR,
    error,
  };
}

export function toggleRoaming(data) {
  return {
    type: TOGGLE_ROAMING,
    data,
  };
}

export function toggleTabs(data) {
  return {
    type: TOGGLE_TABS,
    data,
  };
}

export function setTableFilters(name, filter) {
  if (filter === 'empty') {
    return {
      type: TABLE_FILTERS_CLEAR,
      name,
    };
  }
  return {
    type: TABLE_FILTERS,
    name,
    filter,
  };
}

export function fetchExpenses() {
  return (dispatch, getState) => {
    dispatch(fetchExpensesStart());
    const {
      detalizationNew: { periodSelection },
      application: { isPorted },
    } = getState();

    axios.get(`/api/profile/detalization/expensestructure${isPorted ? 'ported' : ''}/`, {
      params: {
        periodStart: formatDate(periodSelection.startPeriod),
        periodEnd: formatDate(periodSelection.endPeriod),
      },
    })
      .then(({ data }) => {
        if (data.tooManyTransactions) {
          dispatch(fetchExpensesError('TOO_MANY_TRANSACTIONS'));
          return;
        }
        dispatch(fetchExpensesSuccess({ ...data, periodSelection }));
      })
      .catch((error) => {
        console.warn(error);
        dispatch(fetchExpensesError(error, true));
      });
  };
}
